var ScrollTrigger = (function (window) {

  "use strict";

  var ScrollTrigger = function(options) {
    this.points = options.points;
    this.position = { a: 0, b: 0, direction: 0 };
    this.refresh();
  };

  ScrollTrigger.prototype = {

    // Cross browser scrollTop method
    // Returns browser scroll position

    scrollTop: function() {
      if (typeof window.pageYOffset !== 'undefined'){
        return window.pageYOffset;
      } else {
        var a = document.body,
            b = document.documentElement;
        var element = (b.clientHeight) ? b : a;
        return element.scrollTop;
      }
    },

    // Returns scroll direction as 1 or -1

    direction: function() {
      var p = this.position;
      return Math.abs(p.b - p.a) / -(p.b - p.a);
    },

    // Cache the 'from', 'to' and 'at' return values
    // Returns ScrollTrigger object

    cachePoints: function() {
      var methods = ['from', 'to', 'at'], i, j;

      for (i = 0; i < this.points.length; i++) {
        var point = this.points[i],
            cache = this.points[i].cache = {};

        for (j = 0; j < methods.length; j++) {
          var method = methods[j];
          if (point.hasOwnProperty(method)) {
            cache[method] = point[method].call();
          }
        }
      }

      return this;
    },

    // Loops through points and triggers them if it should
    // Returns ScrollTrigger object

    checkPoints: function() {
      var p = this.position, i;

      this.active = [];

      p.a = this.scrollTop();
      p.direction = this.direction();

      for (i = 0; i < this.points.length; i++) {
        var point = this.points[i],
            cache = this.points[i].cache;

        if (cache.hasOwnProperty('at')) {
          this.at(point);
        } else {

          if (!this.between(point)) {

            // If not between the 'from' and 'to' values, then manually test them
            // This is to force start and end states

            this.at(point, 'from');
            this.at(point, 'to');
          }

        }
      }

      // Sort all affected points as per the scroll direction

      if (this.active.length) {
        this.active.sort(function(a, b) {

          var y1 = (a.e.type === 'at') ? a.e.target : a.e.scrollTop;
          var y2 = (b.e.type === 'at') ? b.e.target : b.e.scrollTop;

          return (p.direction === 1) ? y1 - y2 : y2 - y1;

        });

        for (i = 0; i < this.active.length; i++) {
          var active = this.active[i];
          active.point.trigger(active.e)
        }
      }

      p.b = p.a;
      return this;
    },

    // Tests if between 'from' and 'to'
    // Returns boolean, true if triggered

    between: function(point) {
      var p = this.position;
      var cache = point.cache;

      if (p.a < cache.from || p.a > cache.to) {
        return false;
      }

      var percent = (cache.to - cache.from) / 100;

      var e = {
        type: 'between',
        scrollTop: p.a,
        direction: p.direction,
        pixels: p.a - cache.from,
        percent: (p.a - cache.from) / percent
      };

      this.active.push({ point: point, e: e });

      return true;
    },

    // Tests if scroll position crosses a certain point
    // Returns boolean, true if triggered

    at: function(point, method) {
      var p = this.position;
      var y = (method) ? point.cache[method] : point.cache.at;

      if (!(p.a <= y && p.b > y) &&  !(p.a > y && p.b <= y)) {
        return false;
      }

      var e = {
        type: 'at',
        target: y,
        scrollTop: p.a,
        direction: p.direction
      };

      if (method === 'from') {
        e.pixels = 0;
        e.percent = 0;
      }

      if (method === 'to') {
        e.pixels = point.cache.from - point.cache.to;
        e.percent = 100;
      }

      this.active.push({ point: point, e: e });
      
      return true;
    },

    // Re-caches and re-checks all points
    // Returns ScrollTrigger object

    refresh: function() {
      this.cachePoints();
      this.checkPoints();

      return this;
    }

  };


  return ScrollTrigger;

})(window);